<template>
  <loader
    v-show="commonStore.loader"
    name="spinning"
    object="#0A6906"
    size="5"
    speed="2"
    bg="#343a40"
    objectbg="#E4F6E7"
    opacity="20"
    loadingText=""
    :disableScrolling="false"
  ></loader>
  <header-box-2/>
  <main :class="pageClass">
      <router-view @updatePageClass="handlePageClass"></router-view>
  </main>
  <footer-box-3/>
  <modal-access
      title="Start caring for plants with us"
      text="Daily care for your plants has never been so easy and enjoyable. Join us to see for yourself!"
  />
</template>

<script>
import { useAuthStore, useCommonStore, useEnabledStore } from "@/stores";
import { RouterView } from "vue-router";
import HeaderBox2 from "@/components/layouts/header/HeaderBox2.vue";
import FooterBox3 from "@/components/layouts/footer/FooterBox3.vue";
import ModalAccess from "@/components/modals/ModalAccess.vue";
import { detectAndSaveSource } from '@/helpers/detectTWA';
import { isTWA } from '@/helpers/detectTWA'
  export default {
    components: {
      ModalAccess,
      FooterBox3,
      HeaderBox2,
      RouterView
    },
    data() {
      return {
        pageClass: '',
        commonStore: useCommonStore(),
        authStore: useAuthStore(),
        enabledStore: useEnabledStore(),
      };
    },
    watch: {
      $route(to, from) {
        this.pageClass = '';
      },
    },
    methods: {
      handlePageClass(newClass) {
        this.pageClass = newClass;
      },
      async checkPortalType() {
        this.enabledStore.checkPortalType();
      },

    },
    created() {
      this.checkPortalType();
      detectAndSaveSource()
    },
    mounted() {
      document.getElementById('app').classList.toggle('app-twa', this.isTwa)
    },
    computed: {
      isAuth() {
        return this.authStore.isAuth;
      },
      isPortalTypeBooks() {
        return this.enabledStore.isPortalTypeBooks;
      },
      isTwa() {
        return isTWA()
      }
    },
  };
</script>
